import { useContext } from "react";
import { AppContext } from "./AppContext";

interface Props {
    children: any;
    ops: string[];
    fallback?: JSX.Element | null;
    strategy?: "some" | "all";
}

export function MultiPermissionAuthorize({
    children,
    ops,
    fallback = null,
    strategy = "all",
}: Props) {
    const appCtx = useContext(AppContext);

    if (ops.length === 0) {
        return children;
    }

    const userOps = Array.isArray(appCtx.user?.ops) ? appCtx.user.ops : [];

    const authorized =
        strategy === "all"
            ? ops.every((op) => userOps.includes(op))
            : ops.some((op) => userOps.includes(op));

    return authorized ? children : fallback;
}
